<template>
  <v-card 
    :flat="!smUp"
    rounded
    :style="smUp ? 'padding: 15px; margin-left: -5%':''">
    <v-data-table
      hide-default-footer
      :headers="headers"
      :items="items"
      :items-per-page="20"
    >
    <template 
      v-slot:item="props">
      <tr
        v-if="smUp"
        class="application_table_row">
        <td
          class="text-left">
          <p 
            v-html="props.item.sTitle"
            class="text_content"
          />
        </td>
        <td
          class="text-left">
          <p 
            v-html="props.item.formatedCreatedAt"
            class="text_content"
          />
        </td>
        <td
          class="text-left">
          <v-chip
            color="#EDEDED"
            class="fileChip"
            v-for="(pdf, i) in props.item.sPdfKeys"
            :key="i">
            <p
              class="fileChipText">
              {{pdf}}
            </p>
          </v-chip>
        </td>
        <td
          class="text-left">
          <v-btn
            fab
            small
            icon
            text
            @click="delete_reports(props.item)">
            <v-icon
              color="black">
              {{delete_icon}}
            </v-icon>
          </v-btn>
          <v-btn
            fab
            small
            icon
            text
             @click="edit_reports(props.item)">
            <v-icon
              color="black">
              {{edit_report_icon}}
            </v-icon>
          </v-btn>
        </td>
      </tr>
      <v-card
        v-else
        style="padding: 10%; margin-bottom: 20px; margin-top: 20px"
        hover
        shaped
        >
        <v-container>
          <v-layout
            row
            justify-center
            wrap>
            <v-flex
              class="attribute_flex"
              xs12
              sm6>
              <v-layout
                row
                justify-center>
                <v-layout
                  style="max-width: 60%"
                  row>
                  <p
                    class="attribute_name"
                    v-text="'Name: '"
                  />
                  <v-spacer></v-spacer>
                  <p
                    class="attribute_value"
                    v-text="props.item.sTitle"
                  />
                </v-layout>
              </v-layout>
            </v-flex>
            <v-layout
              column>
              <hr
                class="divider_table_mobile">
            </v-layout>
            <v-flex
              class="attribute_flex"
              xs12
              sm6>
              <v-layout
                row
                justify-center>
                <v-layout
                  style="max-width: 60%"
                  row>
                  <p
                    class="attribute_name"
                    v-text="'Date: '"
                  />
                  <v-spacer></v-spacer>
                  <p
                    class="attribute_value"
                    v-text="props.item.formatedCreatedAt"
                  />
                </v-layout>
              </v-layout>
            </v-flex>
            <v-layout
              column>
              <hr
                class="divider_table_mobile">
            </v-layout>
            <v-flex
              class="attribute_flex"
              xs12
              sm6>
              <v-layout
                row
                justify-center>
                <v-layout
                  style="max-width: 60%"
                  row>
                  <p
                    class="attribute_name"
                    v-text="'Files: '"
                  />
                  <v-spacer></v-spacer>
                  <v-chip
                    color="#EDEDED"
                    class="fileChip"
                    v-for="(pdf, i) in props.item.sPdfKeys"
                    :key="i">
                    <p
                      class="fileChipText">
                      {{pdf}}
                    </p>
                  </v-chip>
                </v-layout>
              </v-layout>
            </v-flex>
            <v-layout
              column>
              <hr
                class="divider_table_mobile">
            </v-layout>
            <v-flex
              xs12
              sm12>
              <v-layout
                row
                justify-center>
                <v-layout
                  style="max-width: 50%; margin: 10px"
                  row
                  justify-center>
                  <v-btn
                    fab
                    small
                    icon
                    text
                    @click="delete_reports(props.item)">
                    <v-icon
                      color="black">
                      {{delete_icon}}
                    </v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    icon
                    text
                    @click="edit_reports(props.item)">
                    <v-icon
                      color="black">
                      {{edit_report_icon}}
                    </v-icon>
                  </v-btn>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </template>
    </v-data-table>    
    <reports-edit
      :bActive="b_edit_report"
      :report_to_edit="report_to_edit"
      @close="b_edit_report = false"
      @update="update()"
    />
    <reports-delete
      :bActive="b_delete_operator"
      :report_id="report_to_delete"
      @close="b_delete_operator = false"
      @update="update()"
    />
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      report_to_edit: {},
      report_to_delete: null,
      report_to_edit: null,
      b_edit_report: false,
      b_delete_operator: false,
      delete_icon: 'mdi-delete',
      edit_icon: 'mdi-pencil',
      edit_report_icon: 'mdi-eye',
      headers: [
        { text: 'Name', value: 'sTitle' },
        { text: 'Date', value: 'formatedCreatedAt' },
        { text: 'Files'},
        { text: 'Actions'}
      ]
    }),
    methods: {
      edit_reports (report) {
        this.report_to_edit = report
        this.b_edit_report = true
      },
      update () {
        this.$emit('update')
      },
      delete_reports (report) {
        this.report_to_delete = report._id
        this.b_delete_operator = true
      }
    },
    components: {
      ReportsEdit: () => import('@/components/sections/Admin/Reports/ReportsEdit'),
      ReportsDelete: () => import('@/components/sections/Admin/Reports/ReportsDelete'),
    },
    props: {
      items: Array
    },
    computed: {
      smUp () {
        return this.$vuetify.breakpoint.smAndUp
      }
    }
  }
</script>
<style scoped>
  .fileChipText {
    margin: 10px;
    font-family: 'Open sans', sans-serif;
    font-size: 12px
  }
  .fileChip {
    margin-left: 10px; 
    margin-right: 10px
  }
  .attribute_flex {
    margin-top: 18px;
  }
  hr { 
    height: .5px;
    color: rgba(140, 140, 140, 0.112);
    background-color: rgba(114, 114, 114, 0.112);
    border-color: transparent;

  }
  .attribute_name {
    font-weight: bold;
    color: #000000;
    font-size: 12px;
    font-family: 'Open sans', sans-serif
  }
  .attribute_value {
    color: #000000;
    font-size: 12px;
    font-family: 'Open sans', sans-serif
  }
  .application_table_row {
    cursor: pointer;
  }
  .text_content {
    margin-top: 15px;
    color: #000000;
    font-size: 12px;
    font-family: 'Open sans', sans-serif
  }
</style>